import { render, staticRenderFns } from "./subproperty-customize-page.vue?vue&type=template&id=8522bb8a&scoped=true&"
import script from "./subproperty-customize-page.vue?vue&type=script&lang=js&"
export * from "./subproperty-customize-page.vue?vue&type=script&lang=js&"
import style0 from "./subproperty-customize-page.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./subproperty-customize-page.vue?vue&type=style&index=1&id=8522bb8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8522bb8a",
  null
  
)

export default component.exports